import React, { useState, Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles, MenuItem, Menu } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import SortIcon from "@material-ui/icons/Sort";
import CustomButton from "../../CustomButton/CustomButton";

const useStyles = makeStyles(theme => ({
	toolbarButton: {
		marginLeft: theme.spacing(7)
	},
	menuItem: {
		"&:hover": {
			backgroundColor: theme.palette.primary.light
		}
	}
}));

export default function DropdownMenu({ value, options, onChange }) {
	const classes = useStyles();
	const [selectedValue, setSelectedValue] = useState(value);
	const [anchorEl, setAnchorEl] = useState(null);

	useEffect(() => {
		setSelectedValue(value);
	 }, [value]);

	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	let onChangeSelect = function(event) {
		setSelectedValue(event.target.value.toString());
		setAnchorEl(null);
		onChange(event.target.value);
	};

	return (
		<Fragment>
			<CustomButton
				className={classes.toolbarButton}
				startIcon={<SortIcon />}
				endIcon={<ArrowDropDownIcon />}
				onClick={handleClick}
				size="large"
			>
				{options.find(x => x.value === selectedValue).label}
			</CustomButton>
			<Menu
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				{options.map((option, index) => (
					<MenuItem
						onClick={onChangeSelect}
						key={index}
						value={option.value}
						className={classes.menuItem}
					>
						{option.label}
					</MenuItem>
				))}
			</Menu>
		</Fragment>
	);
}

DropdownMenu.propTypes = {
	label: PropTypes.string,
	value: PropTypes.string,
	options: PropTypes.array,
	onChange: PropTypes.func
};
